export default "https://lightningbookassetsdev.blob.core.windows.net/lightning-ui/1.46.0/ui/f24b2d9707ba36ee.png"